import localDB from "./localDB";

let GLOBAL = require('./globals');

const WarehouseStockData = {
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/warehouse-stock`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/warehouse-stock/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
};

export default WarehouseStockData;


// WEBPACK FOOTER //
// ./src/data/WarehouseStockData.js